// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1RTG-","file":"styles_file__6MuAE"};